// Infinite Scroll Script for Shopify Collections & Search
document.addEventListener('DOMContentLoaded', function() {
  console.log('Lazy load initialized');

  // Run only on collection or search pages
  if (
    !window.location.pathname.includes('/collections/') &&
    !window.location.pathname.includes('/search')
  ) return;

  // Initialize Infinite Scroll
  function initInfiniteScroll() {
    console.log('Init Infinite Scroll');

    // Clean up old observers if re-initializing
    if (window.infiniteScrollObserver) {
      window.infiniteScrollObserver.disconnect();
    }

    let isLoading = false;
    let currentPage = 1;

    const productGrid = document.querySelector('.product-grid') ||
                        document.querySelector('.collection-products') ||
                        document.querySelector('.grid--view-items') ||
                        document.querySelector('.search-page__results');

    // ✅ Always get fresh pagination after reload
    const paginationElement = document.querySelector('.pagination');

    // Hide/remove pagination if found
    if (paginationElement) {
      paginationElement.remove(); // completely remove it
    }

    if (!productGrid) return;

    const loadingIndicator = createLoadingIndicator();
    let nextPageLink = findNextPageLink();

    if (!nextPageLink) return;

    // Remove any old indicator
    const oldIndicator = document.querySelector('.infinite-scroll-loading');
    if (oldIndicator) oldIndicator.remove();

    productGrid.parentNode.insertBefore(loadingIndicator, productGrid.nextSibling);

    // Intersection Observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isLoading && nextPageLink) {
          loadNextPage();
        }
      });
    }, { rootMargin: '0px 0px 200px 0px' });

    observer.observe(loadingIndicator);
    window.infiniteScrollObserver = observer;

    // ---- Functions ----

    function findNextPageLink() {
      const newPagination = document.querySelector('.pagination');
      if (newPagination) {
        const nextLink = newPagination.querySelector('a[aria-label="Next page"]') ||
                         newPagination.querySelector('.pagination__next a');
        if (nextLink) return nextLink.href;

        const page2Link = newPagination.querySelector('a[aria-label="Page 2"]') ||
                          newPagination.querySelector('a[title="Page 2"]');
        if (page2Link) return page2Link.href;
      }

      const url = new URL(window.location.href);
      if (url.searchParams.has('page')) {
        currentPage = parseInt(url.searchParams.get('page'));
      }
      url.searchParams.set('page', currentPage + 1);
      return url.toString();
    }

    function createLoadingIndicator() {
      const loadingDiv = document.createElement('div');
      loadingDiv.className = 'infinite-scroll-loading';
      loadingDiv.innerHTML = `
        <div class="loading-indicator" style="text-align: center; padding: 20px; display: none;">
          <div class="loading-spinner" style="display: inline-block; width: 40px; height: 40px; border: 3px solid rgba(0,0,0,.1); border-radius: 50%; border-top-color: #000; animation: spin 1s ease-in-out infinite;"></div>
        </div>
        <style>
          @keyframes spin { to { transform: rotate(360deg); } }
        </style>
      `;
      return loadingDiv;
    }

    function loadNextPage() {
      if (isLoading || !nextPageLink) return;

      isLoading = true;
      const spinner = loadingIndicator.querySelector('.loading-indicator');
      spinner.style.display = 'block';

      fetch(nextPageLink)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const newProductGrid = doc.querySelector('.product-grid') ||
                                doc.querySelector('.collection-products') ||
                                doc.querySelector('.grid--view-items') ||
                                doc.querySelector('.search-page__results');

          if (newProductGrid) {
            const newProducts = newProductGrid.querySelectorAll('.grid__item, .product-card, .product, .search-result__item');
            newProducts.forEach(product => {
              productGrid.appendChild(product.cloneNode(true));
            });

            if (typeof theme !== 'undefined' && theme.reinitProductGridItem) {
              theme.reinitProductGridItem();
            }

            const nextPagination = doc.querySelector('.pagination');
            if (nextPagination) {
              const newNextLink = nextPagination.querySelector('a[aria-label="Next page"]') ||
                                 nextPagination.querySelector('.pagination__next a');
              if (newNextLink) {
                nextPageLink = newNextLink.href;
                currentPage++;
              } else {
                nextPageLink = null;
              }
            } else {
              currentPage++;
              const url = new URL(nextPageLink);
              url.searchParams.set('page', currentPage + 1);

              fetch(url.toString(), { method: 'HEAD' })
                .then(response => {
                  nextPageLink = response.ok ? url.toString() : null;
                })
                .catch(() => { nextPageLink = null; });
            }
          } else {
            nextPageLink = null;
          }
        })
        .catch(error => {
          console.error('Error loading next page:', error);
          nextPageLink = null;
        })
        .finally(() => {
          isLoading = false;
          spinner.style.display = 'none';
          if (!nextPageLink) {
            observer.unobserve(loadingIndicator);
            loadingIndicator.remove();
          }
        });
    }
  }

  // Init first time
  initInfiniteScroll();

  // Re-init after Shopify Ajax reload (for most themes)
  document.addEventListener('shopify:section:load', initInfiniteScroll);
  document.addEventListener('ajaxProductGrid:updated', initInfiniteScroll);

  // ✅ Fallback: MutationObserver to detect DOM changes (for themes that don’t fire events)
  const container = document.querySelector('#MainContent') || document.body;
  if (container) {
    const mo = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        if ([...mutation.addedNodes].some(node =>
          node.nodeType === 1 &&
          (node.querySelector?.('.product-grid, .collection-products, .grid--view-items, .search-page__results'))
        )) {
          console.log('DOM changed → reinit infinite scroll');
          initInfiniteScroll();
          break;
        }
      }
    });
    mo.observe(container, { childList: true, subtree: true });
  }
});
